export default {
  filters: {
    brands: [],
    types: [],
    categories: [],
  },
  settings: {
    main_banner: {
      header: '',
      subHeader: '',
      image: '',
    },
    first_section: {
      header: '',
      tag: '',
    },
  },
  resources: {
    recent: {
      results: [],
    },
    compliance: {
      results: [],
    },
    searchResults: {
      results: [],
    },
  },
};
